<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Radiology</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">B.Sc. in Medical Radiology and Imaging Technology</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">B.Sc. in Medical Radiology and Imaging Technology</b>
                    – The ARNI School of Allied Health Sciences offers a three-year undergraduate degree called a
                    Bachelor of Science in Radiology and Imaging Technology. The principles and applications of imaging
                    technologies used in medical diagnosis and therapy are the main focus. Comprehensive instruction in
                    imaging modalities like X-ray, MRI, CT scan, ultrasound, and nuclear medicine is part of the BSc in
                    Radiology and Imaging Technology program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Commutative English I</li>
                    <li> Human Anatomy as Applied to Radiology & Imaging I</li>
                    <li> Human Physiology I</li>
                    <li> Pathology I</li>
                    <li> Radiological Physics I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Commutative English II</li>
                    <li> Human Anatomy, Radiology & Imaging II</li>
                    <li> Human Physiology II</li>
                    <li> Biochemistry I</li>
                    <li> Basic & Radiation Physics I (LAB)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Imaging Techniques – I</li>
                    <li> Radiographic Positioning – I</li>
                    <li> Microbiology - I</li>
                    <li> Pathology – II</li>
                    <li> Human Anatomy, Radiology & Imaging –I (LAB)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> Patient Care & Medical Ethics of Radiology –I</li>
                    <li> Radiographic Positioning – II</li>
                    <li> Imaging Techniques – II</li>
                    <li> Research Methodology and Statistics</li>
                    <li> Introduction to Biochemistry</li>
                    <li> VAC</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Dark Room Techniques– I</li>
                    <li> Research Methodology and Statistics</li>
                    <li> Microbiology – II</li>
                    <li> Clinical Radiology – I</li>
                    <li> Dark Room Techniques (LAB)</li>
                    <li> Open Elective</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Radiographic Introductions of Extremities</li>
                    <li> Radiographic Technique & Parameters</li>
                    <li> Advancements in Imaging Technologies</li>
                    <li> Open Elective</li>
                    <li> RBL (Research Based Learning)</li>
                    <li> Radiographic Technique & parameters –II (LAB)</li>
                </ul>
            </div>

        </div>

    </div>
</section>
